const removeAccessTokenFromHash = () => {
  window.location.hash = '';
};

const isBearerToken = (accessToken) => {
  return accessToken && accessToken.token_type === 'bearer';
};

export default {
  getAccessTokenFromHash: () => {
    const dataHash = window.location.hash;
    if (dataHash === '') {
      return undefined;
    }
    let data = dataHash;
    if (data.indexOf('#') === 0) {
      data = data.substring(1).split('&');
    }
    const accessToken = data.reduce((acc, param) => {
      const keyValue = param.split('=');
      if (keyValue.length === 2) {
        acc[keyValue[0].trim()] = keyValue[1].trim();
      }
      return acc;
    }, {});

    removeAccessTokenFromHash();

    return isBearerToken(accessToken) ? accessToken : undefined;
  },
  redirectToOauth: () => {
    const oauthUri = process.env.VUE_APP_OAUTH;
    const oauthAppId = process.env.VUE_APP_CLIENT_ID;
    const redirectUrl = window.location.href.split('#')[0];
    const originUrl = new URL(document.referrer).origin;
    const url = `${oauthUri}/o/oauth2/auth?redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=token&client_id=${oauthAppId}&state=${originUrl}`;
    window.location.replace(url);
  }
};
